import React from 'react';

const SvgServicesIcon = () => {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path opacity="0.4" d="M17.64 11.3601L10.9067 16.4134V23.8934C10.9067 25.1734 12.4533 25.8134 13.36 24.9068L20.2667 18.0001C21.3733 16.8934 21.3733 15.0934 20.2667 13.9868L17.64 11.3601Z" fill="#292D32"/>
            <path d="M10.9067 8.10657V16.4132L17.64 11.3599L13.36 7.0799C12.4533 6.18657 10.9067 6.82657 10.9067 8.10657Z" fill="#292D32"/>
        </svg>
    );
};

export default SvgServicesIcon;